export type ThemeId = "blue" | "violet" | "emerald" | "rose" | "zinc";
export type FontId = "inter" | "geist" | "manrope" | "jakarta" | "plex" | "dmsans";
export type ThemeMode = "light" | "dark" | "system";
export type FontSizeId = "small" | "medium" | "large";

export type ThemeOption = {
  id: ThemeId;
  label: string;
  accent: string;
  hint: string;
};

export type FontOption = {
  id: FontId;
  label: string;
  stack: string;
  hint: string;
};

export type ModeOption = {
  id: ThemeMode;
  label: string;
  hint: string;
};

export type FontSizeOption = {
  id: FontSizeId;
  label: string;
  hint: string;
  px: number;
};

export const MODES: ModeOption[] = [
  { id: "light", label: "Light", hint: "Clean & bright" },
  { id: "dark", label: "Dark", hint: "Easy on the eyes" },
  { id: "system", label: "System", hint: "Match your OS" },
];

export const THEMES: ThemeOption[] = [
  { id: "zinc", label: "Graphite", accent: "#3f3f46", hint: "Monochrome, minimal" },
  { id: "blue", label: "Blue", accent: "#2563eb", hint: "Clean, professional" },
  { id: "violet", label: "Violet", accent: "#7c3aed", hint: "Confident, modern" },
  { id: "emerald", label: "Emerald", accent: "#059669", hint: "Fresh, calm green" },
  { id: "rose", label: "Rose", accent: "#e11d48", hint: "Warm, vivid accent" },
];

export const FONTS: FontOption[] = [
  { id: "inter", label: "Inter", stack: "'Inter'", hint: "Neutral UI standard" },
  { id: "geist", label: "Geist", stack: "'Geist'", hint: "Technical, precise" },
  { id: "manrope", label: "Manrope", stack: "'Manrope'", hint: "Geometric, warm" },
  { id: "jakarta", label: "Plus Jakarta", stack: "'Plus Jakarta Sans'", hint: "Humanist, friendly" },
  { id: "plex", label: "IBM Plex", stack: "'IBM Plex Sans'", hint: "Enterprise, distinct" },
  { id: "dmsans", label: "DM Sans", stack: "'DM Sans'", hint: "Crisp, data-friendly" },
];

export const FONT_SIZES: FontSizeOption[] = [
  { id: "small", label: "Small", hint: "15px · compact", px: 15 },
  { id: "medium", label: "Medium", hint: "16px · balanced", px: 16 },
  { id: "large", label: "Large", hint: "17px · accessible", px: 17 },
];

export const DEFAULT_THEME: ThemeId = "zinc";
export const DEFAULT_FONT: FontId = "inter";
export const DEFAULT_MODE: ThemeMode = "system";
export const DEFAULT_FONT_SIZE: FontSizeId = "medium";
